import Vue from 'vue'
import PerfectScrollbar from 'perfect-scrollbar'

export interface IPs extends PerfectScrollbar {}
export interface IPsOptions extends PerfectScrollbar.Options {}

Vue.prototype.$ps = (element: HTMLElement, option?: IPsOptions): IPs => (new PerfectScrollbar(element, option))
